import * as React from "react";
import { useState, useEffect } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
  CircleMarker,
  Polygon,
  SVGOverlay,
  Tooltip,
  FeatureGroup,
  useMap,
    GeoJSON
} from "react-leaflet";
import L from "leaflet";
import BusinessIcon from '@mui/icons-material/Business';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import ContrastIcon from '@mui/icons-material/Contrast';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import FactoryIcon from '@mui/icons-material/Factory';
import "./FxMap.css";
import {Image, WbSunny} from "@mui/icons-material";
import DongMenuButton from "./DongMenuButton";
import LinearProgress from '@mui/material/LinearProgress';
import {FxmsData} from "../../../datas/FxData";
import {TextField} from "@mui/material";
import MarkerInfoForm from "./MarkerInfoForm";
import {TextBox_CemsDash001DataMart} from "../box/TextBox_CemsDash001DataMart";
import {IndustMapDataMart} from "./IndustMapDataMart";


const THINGSPIRE_LAT_LNG = [37.547005936682226, 126.97392404079439];

const IndustMap = (props) => {
  const { id, fxUiGrpItem, editable, markerDatas, lock } = props;
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([{
    facNo: 1000000,
    key: "1",
    coord: { lat: 37.547005936682226, lng: 126.97392404079439 },
    name: "띵스파이어",
    desc:"서울시 한강대로96길 27 띵스파이어", img:'thingspire.png'
  }]);
  const [loading, setLoading] = useState(false)
  //국토부 - 브이월드
  const [mapSource, setMapSource] = useState("Base");
  const [icon, setIcon] = useState('thingspire.jpg');
  const [sandanPolygon, setSandanPolygon] = useState([])
  const [cityPolygon, setCityPolygon] = useState([])
  const [dongPolygon, setDongPolygon] = useState([])
  const [address,setAddress] = useState('')
  const [addrMode, setAddrMode] = useState('road')
  const [center, setCenter] = useState(THINGSPIRE_LAT_LNG)
  const [zoom, setZoom] = useState(12)
  const [markerInfoFormOpen, setMarkerInfoFormOpen] = useState(false)
  const [latlng, setLatlng] = useState({})
  const [fxCfInlo,setFxCfInlo] = useState([])
  const [api, setApi] = useState('')
  const [designOptions, setDesignOptions] = useState({

  })
  // polygon style
  const [defaultStyle, setDefaultStyle] = useState({
    weight:1,color:'#001f6c'
  })
  const [highlightStyle, setHighlightStyle] = useState({
    weight:5,color:'#00ff00'
  })
  const [importantStyle, setImportantStyle] = useState({
    weight:3,color:'#006c00'
  })

  useEffect(() => {
    // let data = props.item.fxUiDashbItemAttrs
    // if(data){
    //   if(data.length > 0){
    //     let markerData = []
    //     data.map(x=>{
    //       if(x.attrName== 'api'){
    //         setApi(x.attrVal)
    //       }else if(x.attrName == 'center'){
    //         console.log("set center",x.attrVal.split(','))
    //         setCenter(x.attrVal.split(','))
    //       }else if (x.attrName == 'zoom'){
    //         console.log("set zoom",x.attrVal)
    //         setZoom(parseInt(x.attrVal))
    //       }else{
    //         let name = x.attrName
    //         let value = x.attrVal.split("|")
    //         markerData.push({
    //           name:name, peakRatio:value[5], statusColor:value[6], img:value[2], coord:{lat:value[3],lng:value[4], desc:value[1]}
    //         })
    //       }
    //
    //     })
    //     setMarkers(markerData)
    //     if(map) map.setView(center,zoom)
    //   }
    // }
  }, []);

  //외부 url 임시
  useEffect(()=>{
    fetch(api).then((response)=>{
      return response.json()
    }).then(data=>{
      let markerData = []
      data.map(x=>{
        markerData.push({
          name:x._3, peakRatio:x._14+'%', statusColor:x._0, img:'', coord:{lat:x._13.latitude,lng:x._13.longitude}, desc:''
        })
      })
      setMarkers(markerData)
    })
  },[api])
  const updateAttrData = (e) => {
    let data = props.item.fxUiDashbItemAttrs
    let tempCenter = []
    let tempZoom = 0
    if(data){
      if(data.length > 0){
        let markerData = []
        data.map(x=>{
          if(x.attrName== 'api'){
            setApi(x.attrVal)
          }else if(x.attrName == 'center'){
            tempCenter = x.attrVal.split(',')
            setCenter(x.attrVal.split(','))
          }else if (x.attrName == 'zoom'){
            setZoom(parseInt(x.attrVal))
            tempZoom=parseInt(x.attrVal)
          }else{
            let name = x.attrName
            let value = x.attrVal.split("|")
            markerData.push({
              name:name, peakRatio:value[5], statusColor:value[6], img:value[2], coord:{lat:value[3],lng:value[4], desc:value[1]}
            })
          }

        })
        setMarkers(markerData)
        e.target.setView(tempCenter,tempZoom)
      }
    }
  }
  const getSandanPolygon = () => {
    setLoading(true)
    fetch("http://175.123.142.155:11880/sandanPolygon").
    then(function (response) {
      return response.json()
    }).then(function (data) {
      setLoading(false)
      setSandanPolygon(data)
    })
  }
  const getCityPolygon = () => {
    setLoading(true)
    fetch("http://175.123.142.155:11880/cityFence").
    then(function (response) {
      return response.json()
    }).then(function (data) {
      setLoading(false)
      setCityPolygon(data.response.result.featureCollection.features)
    })
  }
  const getDongPolygon = (city) => {
    setDongPolygon([])
    setLoading(true)
    if(city == "삭제"){
      setLoading(false)
    }else{
      fetch("http://175.123.142.155:11880/dongFence"+"?attrFilter=full_nm:LIKE:"+city).
      then(function (response) {
        return response.json()
      }).then(function (data) {
        setLoading(false)
        setDongPolygon(data.response.result.featureCollection.features)
      })
    }

  }
  const getGeoCoding = (addr) => {
    setLoading(true)
    fetch("http://175.123.142.155:11880/geoCoding?address="+addr+"&type="+addrMode).
    then(function (response) {
      return response.json()
    }).then(function (data) {
      setLoading(false)
      let res = data.response.result.point
      map.target.setView([res.y,res.x],18)
    })
  }
  const getGeoCodingClick = () => {
    setLoading(true)
    fetch("http://175.123.142.155:11880/geoCoding?address="+address+"&type="+addrMode).
    then(function (response) {
      return response.json()
    }).then(function (data) {
      setLoading(false)
      let res = data.response.result.point
      map.target.setView([res.y,res.x],18)
    })
  }
  const CreateMarkerEvent = () => {
    const map = useMapEvents({
      click: (e) => {
        let coord = e.latlng;
        setLatlng(e.latlng)
        setMarkerInfoFormOpen(true)
      },
    });

  }
  const saveMarker = (name,desc,img) => {
    setMarkers([...markers,{
      coord: { lat: latlng.lat, lng: latlng.lng },
      name: name,img:img,peakRatio:'',statusColor:'green',
      desc:desc}])
  }
  const MapClickEvent = () => {
    const map = useMapEvents({
      click: (e) => {
        let coord = e.latlng;
        console.log("MapClickEvent", e);
      },
    });
    return null;
  };
  const onEachDong = (feature,layer) =>{
    const name = feature.properties.full_nm
    layer.on('mouseover',(e)=>{
      layer.setStyle(highlightStyle)
      layer.bindPopup(name).openPopup()
      layer.bringToFront()
    })
    layer.on('mouseout',(e)=>{
      layer.setStyle(importantStyle)
      layer.bindPopup(name).closePopup()
    })
    layer.on('click',(e)=>{
      map.target.fitBounds(e.target.getBounds())
    })
  }
  const onEachSandan = (feature,layer) => {
    const name = feature.properties.cat_nam + " " + feature.properties.dan_name
    layer.on('mouseover',(e)=>{
      layer.setStyle(highlightStyle)
      layer.bindPopup(name).openPopup()
      layer.bringToFront()
    })
    layer.on('mouseout',(e)=>{
      if(feature.properties.cat_nam == "국가산업단지"){
        layer.setStyle(importantStyle)
      }else{
        layer.setStyle(defaultStyle)
      }
      layer.bindPopup(name).closePopup()
    })
    layer.on('click',(e)=>{
      map.target.fitBounds(e.target.getBounds())
    })
  }
  const onEachCity = (feature,layer) => {
    const name = feature.properties.ctp_kor_nm
    layer.on('mouseover',(e)=>{
      layer.setStyle(highlightStyle)
      layer.bindPopup(name).openPopup()
      layer.bringToFront()
    })
    layer.on('mouseout',(e)=>{
      layer.setStyle(importantStyle)
      layer.bindPopup(name).closePopup()
    })
    layer.on('click',(e)=>{
      map.target.fitBounds(e.target.getBounds())
    })
  }

  const deleteAllPolygon = () => {
    setDongPolygon([])
    setSandanPolygon([])
    setCityPolygon([])
  }
  //Fx_Cf_Inlo 회사 목록 200개 이하중, 좌표정보가 있는 회사는 1개
  const getFxCfInlo = () => {
    let list = []
    FxmsData.GET('fxCfInlo/list').then(res=>{
      res.data.map(x=>{
        if(x.lnd){
          if(x.lnd != 0){
            if(x.lnd != -1){
              list.push(x)
            }
          }
        }
      })
      setFxCfInlo(list)
      console.log(list)
    })

  }

  const saveCurrentData = () => {
    let currentData = []
    markers.map(x=>{
      currentData.push({uiNo:props.item.uiNo,attrName:x.name,attrVal:x.name+"|"+x.desc+"|"+x.img+"|"+x.coord.lat+"|"+x.coord.lng+"|"+x.peakRatio+"|"+x.statusColor,attrType:'string'})
    })
    currentData.push({uiNo:props.item.uiNo,attrName:"api",attrVal:api,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:"center",attrVal:center[0]+','+center[1],attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:"zoom",attrVal:zoom+'',attrType:'string'})
    console.log(currentData)
    props.save(currentData,props.item.uiNo,props.item.opId)
  }
  const SaveCenter = () => {
    const map = useMapEvents({
      dragend: (e) => {
        setZoom(e.target.getZoom())
        setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
        saveCurrentData()
        // console.log("mapCenter", e.target.getCenter());
        // console.log("map bounds", e.target.getBounds());
      }
    });
    return null;
  }
  let MarkerCustom = (color)=>{
    color = "url(#" + color +")"
    return L.divIcon({
      html: `
                <svg
                    width="99"
                    height="122"
                    fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                 <defs>
                <linearGradient id="b">
                 <stop stop-color="black" offset="0"/>
                 <stop stop-color="black" offset="1"/>
                </linearGradient>
                <linearGradient id="r">
                 <stop stop-color="#f80404" offset="0"/>
                 <stop stop-color="#ea8888" offset="1"/>
                </linearGradient>
                <linearGradient id="o">
                 <stop stop-color="#f85904" offset="0"/>
                 <stop stop-color="#f6a07c" offset="1"/>
                </linearGradient>
                <linearGradient id="y">
                 <stop stop-color="#f8c704" offset="0"/>
                 <stop stop-color="#ead388" offset="1"/>
                </linearGradient>
                <linearGradient id="g">
                 <stop stop-color="#04f86e" offset="0"/>
                 <stop stop-color="#88eaaf" offset="1"/>
                </linearGradient>
                <linearGradient y2="-0.004651" x2="0.498125" y1="0.971494" x1="0.498125" id="red" xlink:href="#r" />
                <linearGradient y2="-0.004651" x2="0.498125" y1="0.971494" x1="0.498125" id="orange" xlink:href="#o" />
                <linearGradient y2="-0.004651" x2="0.498125" y1="0.971494" x1="0.498125" id="green" xlink:href="#g" />
                <linearGradient y2="-0.004651" x2="0.498125" y1="0.971494" x1="0.498125" id="yellow" xlink:href="#y" />
                <linearGradient y2="-0.004651" x2="0.415917" y1="0.490437" x1="0.415917" id="d" xlink:href="#b"/>
               </defs>
               <g>
                <title>Layer 1</title>
                <rect id="svg_1" fill="#fff" width="12.625" height="14.5" x="411.279" y="508.575"/>
                <path stroke="url(#d)" id="svg_2" stroke-linecap="round" stroke-width="1.1" fill=${color} d="m14.095833,1.55c-6.846875,0 -12.545833,5.691 -12.545833,11.866c0,2.778 1.629167,6.308 2.80625,8.746l9.69375,17.872l9.647916,-17.872c1.177083,-2.438 2.852083,-5.791 2.852083,-8.746c0,-6.175 -5.607291,-11.866 -12.454166,-11.866zm0,7.155c2.691667,0.017 4.873958,2.122 4.873958,4.71s-2.182292,4.663 -4.873958,4.679c-2.691667,-0.017 -4.873958,-2.09 -4.873958,-4.679c0,-2.588 2.182292,-4.693 4.873958,-4.71z"/>
                <path id="svg_3" fill="none" stroke-opacity="0.122" stroke-linecap="round" stroke-width="1.1" stroke="#fff" d="m347.488007,453.719c-5.944,0 -10.938,5.219 -10.938,10.75c0,2.359 1.443,5.832 2.563,8.25l0.031,0.031l8.313,15.969l8.25,-15.969l0.031,-0.031c1.135,-2.448 2.625,-5.706 2.625,-8.25c0,-5.538 -4.931,-10.75 -10.875,-10.75zm0,4.969c3.168,0.021 5.781,2.601 5.781,5.781c0,3.18 -2.613,5.761 -5.781,5.781c-3.168,-0.02 -5.75,-2.61 -5.75,-5.781c0,-3.172 2.582,-5.761 5.75,-5.781z"/>
               </g>
              </svg>`,
      className: "svg-icon",
      iconSize: [24, 40],
      iconAnchor: [12, 40]
    });
  }
  return (
      <>
        {loading?<LinearProgress color="secondary" />:''}
        {editable?<MarkerInfoForm close={setMarkerInfoFormOpen} open={markerInfoFormOpen} saveMarker={saveMarker}/>:''}
        {editable?<Box sx={{maxWidth:'80%',height:'60px',zIndex:9999,position:'absolute',bottom:40}}>
          <IndustMapDataMart api={setApi} handleCloseAndSave={saveCurrentData}/>
          <TextField label="주소검색" sx={{margin:'5px'}}
                     onKeyPress={(e) => {
                       if (e.key === 'Enter') {
                         getGeoCoding(e.target.value);
                       }
                     }}
          />
          <Button sx={{margin:'5px'}} variant={"contained"} onClick={()=>{lock(!editable)}}>편집잠그기</Button>
          <Button sx={{margin:'5px'}} variant={"contained"} onClick={getGeoCodingClick}>검색</Button>
          <Button sx={{margin:'5px'}} variant={"contained"} onClick={saveCurrentData}>모든설정 저장하기</Button>
          <Button sx={{margin:'5px'}} variant={"contained"} onClick={()=>{setMarkers([])}}>수동마커 지우기</Button>
        </Box>:''}




        <Box sx={{ '& > :not(style)': { m: 1 },backgroundColor:'transparent',position:'absolute',right:30 }}>
          <Fab size="small">
            <div onClick={getCityPolygon}>시</div>
          </Fab>
            <DongMenuButton getData={getDongPolygon}/>
          <Fab size="small">
            <FactoryIcon onClick={getSandanPolygon}/>
          </Fab>
          <Fab size="small">
            <DeleteOutlineIcon onClick={deleteAllPolygon}/>
          </Fab>
          <Fab size="small">
            <WbSunnyIcon onClick={()=>setMapSource("Base")} />
          </Fab>
          <Fab size="small">
            <DarkModeIcon onClick={()=>setMapSource("midnight")}/>
          </Fab>
          {/*<Fab >*/}
          {/*  <ContrastIcon onClick={()=>setMapSource("gray")}/>*/}
          {/*</Fab>*/}

          {/*<Fab >*/}
          {/*  <InvertColorsIcon onClick={()=>setMapSource("Hybrid")}/>*/}
          {/*</Fab>*/}
        </Box>
        <MapContainer
            attributionControl={false}
            style={{ height: "100%", width: "100%" }}
            center={center}
            zoom={zoom}
            scrollWheelZoom={true}
            id={props.id}
            ref={setMap}
            whenReady={updateAttrData}
        >
          <SaveCenter/>
          {mapSource != "" ? (
              <TileLayer
                  attribution="VWorldBase"
                  url={
                    "http://api.vworld.kr/req/wmts/1.0.0/15F21758-CC91-30A2-9404-84075E3DA2D7/"+mapSource+"/{z}/{y}/{x}.png"
                  }
              />
          ) : (
              ""
          )}

          <CreateMarkerEvent />
          {fxCfInlo.length > 0 ? fxCfInlo.map(x=>{
            return <Marker eventHandlers={{click: (e) => {console.log(e)}}}
                key={x.key}
                position={[x.ltd,x.lnd]}
                // icon={new L.Icon({ iconUrl: icon, iconSize: [55, 35] })}
            >
              <Popup>
                <div >
                  <h4>{x.inloName}</h4>
                </div>
              </Popup>
              <Tooltip direction="right" offset={[25, 0]} opacity={1} >
                <div>
                  <h3>{x.inloAllName}</h3>
                </div>
              </Tooltip>
            </Marker>
          }):''}
          {markers.length >0?markers.map(x=>{
            return <Marker
                eventHandlers={{
                  click: (e) => {
                    if(x.coord == e.latlng){
                      props.selectedSite(x)
                    }

                  },
                }}
                key={x.name}
                position={x.coord}
                icon = {MarkerCustom(x.statusColor)}
                // icon={new L.Icon({ iconUrl: 'icon_factory.png', iconSize: [35, 35] })}
            >
              <Popup>
                <div style={{width:'200px'}}>
                  <h4>사업장 : {x.name}</h4>
                  <h4>피크대비 전력 사용현황 : {x.peakRatio}</h4>
                  <h4>상태 : 개선권장</h4>
                  {x.img!="" && <img style={{maxWidth:'100%'}} src={x.img} alt={"image"}/>}
                </div>
              </Popup>
              <Tooltip direction="right" offset={[25, 0]} opacity={1} >
                <div style={{width:'200px'}}>
                  <h4>사업장 : {x.name}</h4>
                  <h4>피크대비 전력 사용현황 : {x.peakRatio}</h4>
                  <h4>상태 : 개선권장</h4>
                  {x.img!="" && <img style={{maxWidth:'100%'}} src={x.img} alt={"image"}/>}
                </div>
              </Tooltip>
            </Marker>
          }):''}
          {sandanPolygon.length == 2?sandanPolygon[1].map(x=>{
            if(x.properties.cat_nam == "국가산업단지"){
              return <GeoJSON data = {x} style={importantStyle} onEachFeature={onEachSandan} />
            }else{
              return <GeoJSON data = {x} style={defaultStyle} onEachFeature={onEachSandan} />
            }

          }):''}
          {sandanPolygon.length == 2?sandanPolygon[0].map(x=>{
            if(x.properties.cat_nam == "국가산업단지"){
              return <GeoJSON data = {x} style={importantStyle} onEachFeature={onEachSandan} />
            }else{
              return <GeoJSON data = {x} style={defaultStyle} onEachFeature={onEachSandan} />
            }
          }):''}
          {cityPolygon.length > 1? cityPolygon.map(x=>{
            return <GeoJSON data = {x} style={importantStyle} onEachFeature={onEachCity} />
          }):''}
          {dongPolygon.length > 1? dongPolygon.map(x=>{
            return <GeoJSON data = {x} style={importantStyle} onEachFeature={onEachDong} />
          }):''}
        </MapContainer>
      </>

  );
};

export { IndustMap };
